import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { categoryPath, formatShortDate } from "@/utils/article";

interface RelatedArticlesProps {
  articles: Article[];
  category: Article["category"];
  categoryName: string;
}

export default function RelatedArticles({ articles, category, categoryName }: RelatedArticlesProps) {
  return (
    <section className="mt-12 border-t border-background-200 pt-10">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">相关文章推荐</h2>
        <Link
          to={categoryPath(category)}
          className="flex cursor-pointer items-center gap-1 text-sm font-medium text-accent-600 transition-colors hover:text-accent-700"
        >
          更多{categoryName}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <Link
            key={article.id}
            to={`/detail/${article.id}`}
            className="group flex cursor-pointer gap-3 rounded-xl border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300"
          >
            <div className="h-16 w-24 shrink-0 overflow-hidden rounded-lg bg-background-200">
              <img
                src={article.cover}
                alt={article.title}
                title={`${article.title} - 台北娜娜`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {article.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-400">{formatShortDate(article.date)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}